import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from '@sentry/react';

import { pomConfig } from '@/configs/pom-config';

export function trace() {
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  init({
    dsn: `${process.env.SENTRY_DSN}`,
    environment: `${pomConfig.env}`,
    integrations: [browserTracingIntegration(), replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', `${pomConfig.http.api}`],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
